import { DestroyRef, inject, Injectable } from '@angular/core';
import { InfoApiService } from './api/info-api.service';
import { Observable, shareReplay } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IEntityFieldHelp } from '../../shared/models/info/entity-field-help';

@Injectable({
  providedIn: 'root',
})
export class EntityFieldHelpService {
  private infoApiService = inject(InfoApiService);
  private entityFieldHelp$: Observable<IEntityFieldHelp[]> | undefined;
  private destroyRef = inject(DestroyRef);

  public getEntityFieldHelp$(): Observable<IEntityFieldHelp[]> {
    if (!this.entityFieldHelp$) {
      this.entityFieldHelp$ = this.infoApiService.getEntityFieldHelp().pipe(shareReplay(1));
    }
    return this.entityFieldHelp$;
  }

  public upsertEntityFieldHelp(entityFieldHelp: IEntityFieldHelp): void {
    this.infoApiService
      .createEntityFieldHelp(entityFieldHelp)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.entityFieldHelp$ = undefined;
      });
  }
}
